export { SysqueToggleButtonModule } from './sysque-switch-button.module';
export { SysqueToggleButtonComponent } from './sysque-switch-button.component';